import React from "react";
import Select from "react-select";
import { STAFF_ROLES, STAFF_ROLE_LABELS } from "../../permissions";

const ROLE_OPTIONS = STAFF_ROLES.map((role) => ({
  value: role,
  label: STAFF_ROLE_LABELS[role],
}));

/** `["FINANCE"]` → `[{value,label}]` para hidratar el select desde la API. */
function rolesToOptions(roles) {
  return (roles ?? [])
    .map((role) => ROLE_OPTIONS.find((o) => o.value === role))
    .filter(Boolean);
}

/** `[{value,label}]` → `["FINANCE"]` para el payload del backend. */
function optionsToRoles(options) {
  return (options ?? []).map((o) => o.value);
}

/**
 * Multi-select de roles de staff. `react-select` con `isMulti` es el patrón de
 * la casa (CreateClassModal): el estado guarda objetos `{value,label}` y se
 * mapea a ids en el submit.
 *
 * A11y: `inputId` debe coincidir con el `controlId` del <Form.Group> que lo
 * envuelve para que la <Form.Label> quede asociada al input real.
 */
function StaffRolesSelect({ inputId, value, onChange, isDisabled }) {
  return (
    <Select
      inputId={inputId}
      isMulti
      options={ROLE_OPTIONS}
      value={value}
      onChange={(selected) =>
        onChange(Array.isArray(selected) ? selected : selected ? [selected] : [])
      }
      isDisabled={isDisabled}
      classNamePrefix="react-select"
      placeholder="Selecciona uno o más roles…"
      noOptionsMessage={() => "Sin roles disponibles"}
    />
  );
}

export { StaffRolesSelect, ROLE_OPTIONS, rolesToOptions, optionsToRoles };
